// @ts-strict-ignore
import {
  useCompanyPagesListQuery,
  useCustomerServicePagesListQuery,
  useLegalPagesListQuery,
  usePageTypeBySlugQuery,
} from "@dashboard/graphql";
import useNavigator from "@dashboard/hooks/useNavigator";
import { mapEdgesToItems } from "@dashboard/utils/maps";
import React from "react";

import PagesListPage from "../components/PagesListPage/PagesListPage";
import { pageDetailsUrl } from "../urls";

export const PagesList: React.FC = () => {
  const navigate = useNavigator();

  // Fetch page type IDs
  const { data: customerServiceTypeData } = usePageTypeBySlugQuery({
    variables: { slug: "customer-service" },
  });

  const { data: legalTypeData } = usePageTypeBySlugQuery({
    variables: { slug: "legal" },
  });

  const { data: companyTypeData } = usePageTypeBySlugQuery({
    variables: { slug: "company" },
  });

  const customerServiceTypeId = customerServiceTypeData?.pageTypes?.edges?.[0]?.node?.id;
  const legalTypeId = legalTypeData?.pageTypes?.edges?.[0]?.node?.id;
  const companyTypeId = companyTypeData?.pageTypes?.edges?.[0]?.node?.id;

  // Fetch pages for each type
  const { data: customerServiceData } = useCustomerServicePagesListQuery({
    variables: {
      first: 100,
      filter: customerServiceTypeId ? { pageTypes: [customerServiceTypeId] } : undefined,
    },
    skip: !customerServiceTypeId,
  });

  const { data: legalData } = useLegalPagesListQuery({
    variables: {
      first: 100,
      filter: legalTypeId ? { pageTypes: [legalTypeId] } : undefined,
    },
    skip: !legalTypeId,
  });

  const { data: companyData } = useCompanyPagesListQuery({
    variables: {
      first: 100,
      filter: companyTypeId ? { pageTypes: [companyTypeId] } : undefined,
    },
    skip: !companyTypeId,
  });

  const customerServicePages = mapEdgesToItems(customerServiceData?.pages) || [];
  const legalPages = mapEdgesToItems(legalData?.pages) || [];
  const companyPages = mapEdgesToItems(companyData?.pages) || [];

  const handlePageClick = (id: string) => {
    navigate(pageDetailsUrl(id));
  };

  return (
    <PagesListPage
      customerServicePages={customerServicePages}
      legalPages={legalPages}
      companyPages={companyPages}
      onPageClick={handlePageClick}
    />
  );
};

export default PagesList;
